export const dataSelectionModal = 'dataSelectionModal';
export const widthSelectionModal = 'calc(100% - 120px)';
